/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const MarginGdcBarChart = ({ labels = [], datasets = [] }) => {
  const chartData = {
    labels: labels.map((d) => d.label),
    datasets: datasets.map(() => ({
      yAxisID: "y",             // IMPORTANT – prevents stacking
      barPercentage: 0.8,
      categoryPercentage: 0.6,
      borderRadius: 2,
    })),
  };
  
  // const options = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   interaction: {
  //     mode: 'index',
  //     intersect: false,
  //   },
  //   layout: {
  //     padding: {
  //       top: 20,
  //     },
  //   },
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },

  //     tooltip: {
  //       enabled: true,
  //       callbacks: {
  //         label: (ctx) => {
  //           const val = ctx.parsed?.y ?? ctx.raw;
  //           return `${ctx.dataset.label}: ${val} Lac`;
  //         },
  //       },
  //     },
  //     datalabels: {
  //       color: "black",
  //       textStrokeColor: "white",
  //       textStrokeWidth: 4,
  //       anchor: "end",
  //       align: "end",
  //       // rotation: 90, 
  //       // display: "auto",
  //       // clip: "auto",
  //       font: {
  //         weight: "bold",
  //         size: 10,
  //       },
  //     },
  //   },
  //   scales: {
  //     y: {
  //       beginAtZero: true,
  //       ticks: {
  //         display:true,
  //         font: { size: 8 },
  //         callback: (value) => `${value} Lac`,
  //       },
  //       grid: { display: true },
  //     },
  //     x: {
  //       ticks: {
  //         display: true,
  //         font: { size: 9 },
  //       },
  //     },
  //   },
  // };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    layout: {
      padding: { top: 20 },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (ctx) => {
            const val = ctx.parsed?.y ?? ctx.raw;
            return `${ctx.dataset.label}: ${val} Lac`;
          },
        },
      },
      datalabels: {
        color: "black",
        textStrokeColor: "white",
        textStrokeWidth: 4,
        anchor: "end",
        align: "end",
        font: { weight: "bold", size: 10 },
      },

    },
    scales: {
      y: {
        beginAtZero: true,
        stacked: false,     // 🔥 IMPORTANT
        ticks: {
          display: true,
          font: { size: 8 },
          callback: (value) => `${value} Lac`,
        },
        grid: { display: true },
      },
      x: {
        stacked: false,     // 🔥 IMPORTANT
        ticks: {
          display: true,
          font: { size: 9 },
        },
      },
    },
  };
  

  return (
    <div style={{ width: '100%', height: "180px" ,marginTop:"10px"}}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default MarginGdcBarChart;